import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Industries',
    href: '#industries'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }];
  return <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-dark/90 backdrop-blur-md py-4 border-b border-white/10' : 'bg-transparent py-6'}`} data-id="element-150">
      <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-151">
        <a href="#" className="flex items-center" data-id="element-152">
          <img src="https://cdn.magicpatterns.com/uploads/eGy4RwjVoVa91269krSrRo/pasted-image.png" alt="Deskmayte Logo" className="h-8 w-auto brightness-0 invert" data-id="element-153" />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-154">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium hover:text-brand-accent transition-colors" data-id="element-155">
              {link.name}
            </a>)}
          <a href="#book-call" className="bg-brand-accent text-brand-dark px-6 py-2.5 rounded-full text-sm font-bold hover:bg-white transition-all transform hover:scale-105" data-id="element-156">
            Book Discovery Call
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-157">
          {isMobileMenuOpen ? <X data-id="element-158" /> : <Menu data-id="element-159" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="absolute top-full left-0 w-full bg-brand-dark border-b border-white/10 p-6 md:hidden max-h-[80vh] overflow-y-auto" data-id="element-160">
          <div className="flex flex-col space-y-4" data-id="element-161">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium" onClick={() => setIsMobileMenuOpen(false)} data-id="element-162">
                {link.name}
              </a>)}

            {/* Mobile Offer Section */}
            <div className="mt-6 p-5 bg-slate-900 border border-brand-accent/30 rounded-2xl shadow-lg" data-id="element-163">
              <h4 className="text-white font-serif font-bold text-lg mb-4 leading-tight" data-id="element-164">
                Need Help Reaching Overdue Patients?
              </h4>

              <div className="mb-4" data-id="element-165">
                <h5 className="text-brand-accent font-bold text-base mb-1" data-id="element-166">
                  Pay Per Booking
                </h5>
                <p className="text-slate-300 text-xs mb-3" data-id="element-167">
                  Pay as we book your overdue patients.
                </p>
                <a href="#book-call" onClick={() => setIsMobileMenuOpen(false)} className="block text-center w-full bg-brand-accent text-brand-dark font-bold py-2.5 rounded-xl text-sm hover:bg-white transition-colors" data-id="element-168">
                  Get Started
                </a>
              </div>

              <div className="h-px w-full bg-white/10 my-4" data-id="element-169" />

              <div data-id="element-170">
                <h5 className="text-white font-bold text-sm mb-1" data-id="element-171">
                  Patient Coordination – $399
                </h5>
                <p className="text-slate-400 text-xs mb-3" data-id="element-172">
                  Inbound & Outbound Call Management
                </p>
                <a href="#scale-business" onClick={() => setIsMobileMenuOpen(false)} className="block text-center w-full bg-white/5 border border-white/10 text-white font-bold py-2 rounded-xl text-xs hover:bg-white/10 transition-colors" data-id="element-173">
                  Learn More
                </a>
              </div>
            </div>

            <a href="#book-call" className="bg-brand-accent text-brand-dark px-6 py-3 rounded-xl text-center font-bold mt-4" onClick={() => setIsMobileMenuOpen(false)} data-id="element-174">
              Book Discovery Call
            </a>
          </div>
        </motion.div>}
    </nav>;
}